import { formatDate, formatDateTime, parseDate } from "@patterns/core";
var DataTableGlobal = /** @class */ (function () {
    function DataTableGlobal() {
    }
    DataTableGlobal.formatDate = function (date) { return formatDate(date); };
    DataTableGlobal.formatDateTime = function (date) { return formatDateTime(date); };
    DataTableGlobal.parseDate = function (date) { return parseDate(date); };
    return DataTableGlobal;
}());
export { DataTableGlobal };
//# sourceMappingURL=data-table-global.js.map